import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" }));
export default SvgAdd;
